import { __assign, __rest } from "tslib";
export function useRadioGroup(props) {
    var onChange = props.onChange, disabled = props.disabled, readOnly = props.readOnly, restProps = __rest(props, ["onChange", "disabled", "readOnly"]);
    return {
        rootProps: __assign(__assign({}, restProps), { role: 'radiogroup', 'aria-disabled': disabled, 'aria-readonly': readOnly }),
    };
}
